import { Component, OnInit ,Inject} from '@angular/core';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
@Component({
    selector: 'app-verify-popup',
    templateUrl: './verify-popup.component.html'
    // styleUrls: ['./verify.popup.component.scss'],
  })

  export class VerifyPopupComponent implements OnInit
  {

    
    emailDetail;
    mobileDetail;
    
    constructor( @Inject(MAT_DIALOG_DATA) public data: any)
    {
        console.log(this.data);
    }
    ngOnInit(): void 
    {
       this.emailDetail=this.data.email;
       this.mobileDetail=this.data.mobile;
    }

downloadFile()
{
    const link = document.createElement('a');
  link.href =  '../../../../assets/images/SOP_for_User_profile_Update.docx';
link.download = 'userCreationSOP.docx'; // file name for user
link.click();
}
   
  }
